import { render } from "./InfoPageBlock.vue?vue&type=template&id=6333e540&scoped=true"
import script from "./InfoPageBlock.vue?vue&type=script&lang=js"
export * from "./InfoPageBlock.vue?vue&type=script&lang=js"

import "./InfoPageBlock.vue?vue&type=style&index=0&id=6333e540&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6333e540"]])

export default __exports__